import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errMsg(e) {
  return formatApiErrorDetail(e?.response?.data?.detail) || e?.message || "Error";
}

export const fmtNum = (n, d = 0) =>
  (n == null || isNaN(n) ? "0" : Number(n).toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d }));

export const fmtMoney = (n) =>
  "$" + (n == null || isNaN(n) ? "0.00" : Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

export const fmtDate = (s) => (s ? new Date(s).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" }) : "—");
export const fmtDay = (s) => (s ? new Date(s).toLocaleDateString("en-US", { dateStyle: "medium" }) : "—");
